import { Controller, useFormContext } from "react-hook-form";

import type { CommunityMemberSelectProps } from "@/react/components/SettingsApp/CompassCompat/CommunityMemberSelect";
import { CommunityMemberSelect } from "@/react/components/SettingsApp/CompassCompat/CommunityMemberSelect";

export interface FormCommunityMemberSelectProps extends CommunityMemberSelectProps {
  name: string;
}

export const FormCommunityMemberSelect = ({
  name,
  ...passThroughProps
}: FormCommunityMemberSelectProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => (
        <CommunityMemberSelect
          {...passThroughProps}
          name={name}
          onChange={(item: { value: unknown }) => onChange(item.value)}
          value={value}
        />
      )}
    />
  );
};

FormCommunityMemberSelect.displayName = "Form.CommunityMemberSelect";
